import React, { useState, useEffect, useRef } from 'react'
import { Link, useHistory } from 'react-router-dom'
import styled from 'styled-components'
import ChatInput from './ChatInput'
import axios from '../../store/axios-secure'
// import Logout from "./Logout";
import { v4 as uuidv4 } from 'uuid'
import { FaTrashAlt, FaEdit, FaSave, FaTimes } from 'react-icons/fa'
import { AiOutlineSchedule } from 'react-icons/ai'
import Schedule from './Schedule'
import ReactDOM from 'react-dom'

import { IoCheckmarkOutline } from 'react-icons/io5'
import { IoCheckmarkDoneSharp } from 'react-icons/io5'
import { FaReply } from 'react-icons/fa'
import AudioRecorder from '../Common/AudioRecorder'
import Linkify from 'react-linkify'
import { IoMdDownload } from 'react-icons/io'
import { RiFullscreenFill } from 'react-icons/ri'
import Loader from '../Common/Loader'

const CustomLink = ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
    </a>
)
// import { sendMessageRoute, recieveMessageRoute } from "../utils/APIRoutes";

export default function ChatContainer({
    currentChat,
    setCurrentChat,
    socket,
    messages,
    setMessages,
    setShowChatContainer,
    setCurrentSelected,
    isConnected,
    isOnline,
    isReactionMsg,
    setIsReactionMsg,
    onUserMoreMessages,
}) {
    // const [messages, setMessages] = useState([])
    let history = useHistory()

    const [clientId, setClientId] = useState([])
    const scrollRef = useRef()
    const [arrivalMessage, setArrivalMessage] = useState(null)
    const [showSchedule, setShowSchedule] = useState(false)
    const [currAutomatedMessages, setCurrAutomatedMessages] = useState([])
    const [isTyping, setIsTyping] = useState(false) // To track if someone is currently typing
    const [reactMessage, setReactMessage] = useState(null)
    const [replyMessage, setReplyMessage] = useState(null)
    const [hoveredMessage, setHoveredMessage] = useState(null)
    const [scrollToMessage, setScrollToMessage] = useState(null)
    const [userMsgsLoader, setUserMsgsLoader] = useState(false)
    // const [refrenceScrollMsg, setRefrenceScrollMsg] = useState(null) //while fetching more messages, to track scroll
    const emojis = ['👍', '❤️', '😊', '😲', '🙌', '😡']
    const [showReactionBar, setShowReactionBar] = useState(false)
    let [
        audioUrl,
        isRecording,
        startRecording,
        stopRecording,
        audioFile,
        setAudioFile,
        setAudioUrl,
    ] = AudioRecorder()
    const [attachedFiles, setAttachedFiles] = useState([])

    const [scrollToTop, setScrollToTop] = useState(false)
    const chatContainerRef = useRef(null)
    // const [page, setPage] = useState(0);

    const handleScroll = () => {
        if (chatContainerRef.current.scrollTop === 0) {
            setScrollToTop(true)
        } else {
            setScrollToTop(false)
        }
    }
    // const handleScroll = () => {
    //     if (chatContainerRef.current.scrollTop === 0 && !userMsgsLoader) {
    //         setPage(prevPage => prevPage + 1);
    //     }
    // };
    // useEffect(() => {
    //     if (page > 0) {
    //         getUserAllMessages(page);
    //     }
    // }, [page]);

    const getUserAllMessages = async () => {
        try {
            console.log('make an api call.............||||')
            setUserMsgsLoader(true)
            let skip = messages.length || 0
            // let refScrollMsg = skip === 0 ? null : messages[0]

            const response = await axios.get(
                `chat/getMoreMessages?clientId=${clientId}&skip=${skip}&limit=50`,
            )

            if (response.data.code === 1) {
                if (
                    response.data?.messages &&
                    response.data?.messages.length > 0
                ) {
                    onUserMoreMessages(
                        response.data?.chatId,
                        response.data.messages,
                    )
                }
            }
            // setRefrenceScrollMsg(refScrollMsg)
            setUserMsgsLoader(false)
        } catch (error) {
            console.error('Failed to fetch messages:', error)
            setUserMsgsLoader(false)
        }
    }

    // useEffect(() => {
    //     if (refrenceScrollMsg) {
    //         const messageElement = document.getElementById(
    //             refrenceScrollMsg._id,
    //         )

    //         if (messageElement) {
    //             messageElement.classList.add('scroll-target')

    //             messageElement.scrollIntoView({
    //                 // behavior: 'smooth',
    //                 block: 'start',
    //                 inline: 'nearest',
    //             })
    //         }
    //         messageElement.classList.remove('scroll-target')

    //         // setTimeout(() => {
    //         //     messageElement.classList.remove('scroll-target')
    //         // }, 1000)

    //         setRefrenceScrollMsg(null) // Reset scroll target after scrolling
    //     }
    // }, [refrenceScrollMsg])

    useEffect(() => {
        chatContainerRef.current.addEventListener('scroll', handleScroll)
        return () => {
            // if (chatContainerRef && chatContainerRef.current) {
            //     //to resolve error, occurs when closed chatContainer
            //     chatContainerRef.current.removeEventListener(
            //         'scroll',
            //         handleScroll,
            //     )
            // }
            chatContainerRef.current.removeEventListener('scroll', handleScroll)
        }
    }, [])

    useEffect(() => {
        if (scrollToTop) {
            if (messages.length < 50) {
                return
            }
            getUserAllMessages()
        }
    }, [scrollToTop])

    useEffect(() => {
        // console.log('currentChat Change;;;.', currentChat)
        //  setMessages(currentChat?.messages)
        const cId = currentChat?.userRef.toString()
        setClientId(cId)
        setShowSchedule(false)
        setReactMessage(null)
        setReplyMessage(null)
        // setHasMoreMessages(true)
        // setPage(1);
        setUserMsgsLoader(false)
    }, [currentChat])

    useEffect(() => {
        if (!showSchedule) {
            setCurrAutomatedMessages([])
        }
    }, [showSchedule])

    // const handleSendMsg = async (msg) => {
    //     if (msg.trim() === '') {
    //         return
    //     }
    //     const senderType = 'trainer'
    //     //console.log("clientId.........", clientId)
    //     socket.emit('stop_typing', { clientId, senderType })
    //     setReplyMessage(null)
    //     try {
    //         await axios.post(`chat/sendMessage?clientId=${clientId}`, {
    //             content: msg,
    //             senderType: senderType,
    //             replyMessage: replyMessage,
    //         })
    //         // setReplyMessage(null);
    //         // const msgs = [...messages];
    //         // msgs.push({ fromSelf: true, message: msg });
    //         // setMessages(msgs);
    //         // socket.emit('send_message', { clientId, message, senderType })
    //     } catch (error) {
    //         console.error('Failed to send message', error)
    //     }
    // }
    const handleSendMsg = async (msg) => {
        if (msg.trim() === '' && attachedFiles?.length < 1) {
            return
        }
        const senderType = 'trainer'

        const formData = new FormData()
        formData.append('content', msg)
        formData.append('senderType', senderType)

        attachedFiles?.forEach((file) => {
            formData.append('attachments', file)
        })
        // Convert each attached file to base64 and append it to the formData
        // let fileArray = [];
        // if (attachedFiles && attachedFiles.length > 0) {
        //     console.log("inside.......................", attachedFiles);
        //     for (const file of attachedFiles) {
        //         const reader = new FileReader();
        //         reader.readAsDataURL(file);
        //         reader.onload = () => {
        //             // formData.append('attachments', reader.result);
        //             let source = reader.result.split(',')[1];
        //             let name = file?.name;
        //             let type = file?.type;
        //             let fl = {
        //                 name: name, //'foodImage.jpg',
        //                 uri: source,
        //                 type: type,  //'image/jpg',
        //             }
        //             // fileArray.push(JSON.stringify(fl));

        //             console.log("name type and source......", name, type, source, fileArray);
        //             // formData.append('attachments', JSON.stringify(fileArray));
        //             formData.append('attachments', JSON.stringify(fl));

        //             // formData.append('attachments', fileArray);

        //         };

        //     }
        // }

        // let repMessage = replyMessage;
        formData.append('replyMessage', JSON.stringify(replyMessage))
        console.log('formData........', formData)
        socket.emit('stop_typing', { clientId, senderType })
        setReplyMessage(null)

        console.log(
            'attachedFiles.......',
            attachedFiles,
            'formdata...',
            formData,
        )
        setAttachedFiles([])

        try {
            await axios.post(
                `chat/sendMessage?clientId=${clientId}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                },
            )
        } catch (error) {
            console.error('Failed to send message', error)
        }
    }
    // const handleSendAudio = async (audioFile, audioUrl) => {
    //     const senderType = 'trainer'
    //     //console.log("clientId.........", clientId)
    //     // socket.emit('stop_typing', { clientId, senderType })
    //     // let repMessage = replyMessage;
    //     // setReplyMessage(null)
    //     try {
    //         await axios.post(`chat/sendMessage?clientId=${clientId}`, {
    //             // content: null,
    //             senderType: senderType,
    //             // replyMessage: repMessage,
    //             audioUrl: audioUrl,
    //         })
    //         // setReplyMessage(null);
    //         // const msgs = [...messages];
    //         // msgs.push({ fromSelf: true, message: msg });
    //         // setMessages(msgs);
    //         // socket.emit('send_message', { clientId, message, senderType })
    //     } catch (error) {
    //         console.error('Failed to send message', error)
    //     }
    // }
    const handleSendAudio = async (audioFile) => {
        const senderType = 'trainer'

        try {
            // Create a new FileReader
            const reader = new FileReader()

            // Set up the onload callback function
            reader.onload = async () => {
                try {
                    // Convert the audio file to base64
                    const base64Audio = reader.result.split(',')[1] // Get the base64 string without data:audio/*;base64,
                    // console.log('audioBase64.............', base64Audio)
                    // Send the base64-encoded audio data to the backend along with other parameters
                    const response = await axios.post(
                        `chat/sendMessage?clientId=${clientId}`,
                        {
                            senderType: senderType,
                            audioBase64: base64Audio,
                        },
                    )

                    console.log('Audio file sent successfully:', response.data)
                } catch (error) {
                    console.error('Failed to send audio file:', error)
                }
            }

            // Read the audio file as data URL
            reader.readAsDataURL(audioFile)
        } catch (error) {
            console.error('Failed to handle audio file:', error)
        }
    }

    const onScheduleClick = async () => {
        try {
            setShowSchedule(true)
            const response = await axios.get(
                `chat/getAutomatedMessages?clientId=${clientId}`,
            )
            // console.log('response......', response)
            setCurrAutomatedMessages(response?.data?.automatedMessages)
        } catch (err) {
            console.log('error while fetching automatedMessages...', err)
        }
    }

    useEffect(() => {
        if (socket.current) {
            socket.current.on('msg-recieve', (msg) => {
                setArrivalMessage({ fromSelf: false, message: msg })
            })
        }
    }, [])

    useEffect(() => {
        arrivalMessage && setMessages((prev) => [...prev, arrivalMessage])
    }, [arrivalMessage])

    useEffect(() => {
        // scrollRef.current?.scrollIntoView({ behavior: "smooth" });
        if (!isReactionMsg) {
            scrollRef.current?.scrollIntoView()
        } else {
            setIsReactionMsg(false)
        }
    }, [messages])

    const handleReactToMessage = (message) => {
        setReactMessage(message)
        setShowReactionBar(true)
    }
    const handleSelectEmoji = (msg, emoji) => {
        if (msg.senderType === 'trainer') {
            return
        }
        const senderType = 'trainer'
        const icon = emoji
        socket.emit('reacted_message', { clientId, senderType, icon, msg })
        setShowReactionBar(false)
        setReactMessage(null)
    }

    const handleReply = (message) => {
        setReplyMessage(message)
    }

    const DownloadLink = ({ attachment, fileName }) => {
        const handleDownload = () => {
            fetch(attachment)
                .then((response) => response.blob())
                .then((blob) => {
                    const url = window.URL.createObjectURL(new Blob([blob]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', fileName)
                    document.body.appendChild(link)
                    link.click()
                    link.parentNode.removeChild(link)
                })
                .catch((error) => {
                    console.error('Error downloading the file:', error)
                })
        }

        return (
            <IoMdDownload
                style={{ cursor: 'pointer' }}
                onClick={handleDownload}
            />
        )
    }

    useEffect(() => {
        if (scrollToMessage) {
            // Find the element with the matching _id
            const messageElement = document.getElementById(scrollToMessage._id)

            console.log('messageElement....', messageElement)
            if (messageElement) {
                messageElement.classList.add('scroll-target')

                // Scroll to the target message
                messageElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest',
                })
            }
            setTimeout(() => {
                messageElement.classList.remove('scroll-target')
            }, 1000)

            setScrollToMessage(null) // Reset scroll target after scrolling
        }
    }, [scrollToMessage])

    const handleReplyClick = (message) => {
        // setReplyMessage(message);
        console.log('handlingReply..........', message)
        setScrollToMessage(message.replyMessage)
    }

    const onUserNameClicked = () => {
        history.replace({
            pathname: `/workout/${clientId}`,
            state: {
                name: currentChat.userName,
                email: currentChat.userEmail,
                photoUrl: currentChat.userPhotoUrl,
                clientId: clientId,
                // targetSteps:
                //     Number(stepsData),
            },
        })
    }
    return (
        <div>
            {!showSchedule ? (
                <Container style={{ zIndex: 10001 }} className="chat-container">
                    <div className="chat-header">
                        <div className="user-details">
                            <div className="avatar">
                                <img src={currentChat.userPhotoUrl} alt="" />
                            </div>
                            <div
                                className="username"
                                style={{ cursor: 'pointer' }}
                                onClick={onUserNameClicked}
                            >
                                {currentChat.userName}
                                {`   (${currentChat.userTimeZone}) `}
                                {/* {isTyping && (
                                    <div style={{ fontSize: '10px' }}>
                                        typing...
                                    </div>
                                )}
                                {isOnline && !isTyping && (
                                    <div style={{ fontSize: '10px' }}>
                                        online
                                    </div>
                                )} */}
                                {isOnline && (
                                    <div style={{ fontSize: '10px' }}>
                                        online
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* <AiOutlineSchedule
                            style={{ marginRight: '10px', marginLeft: '5px', fontSize: '18px' }}
                            onClick={() => setShowSchedule(true)}
                        /> */}
                        <FaTimes
                            onClick={() => {
                                let leaveType = 'trainer'
                                console.log('emitting room...', clientId)
                                socket.emit('leave_room', {
                                    clientId,
                                    leaveType,
                                })
                                setCurrentChat(undefined)
                                setCurrentSelected(undefined)
                            }}
                        />
                        {/* <Logout /> */}
                    </div>

                    <div className="chat-messages" ref={chatContainerRef}>
                        {userMsgsLoader && (
                            <div>
                                <Loader />
                            </div>
                        )}
                        {/* {!hasMoreMessages &&
                            (<div>
                                no more messages!
                            </div>
                            )
                        } */}
                        {messages.map((message, index) => (
                            <div
                                ref={scrollRef}
                                key={message._id}
                                // key={index}
                                id={message._id}
                            >
                                <div
                                    className={`message ${
                                        message.senderType === 'trainer'
                                            ? 'sended'
                                            : 'recieved'
                                    }`}
                                    // onSwipe={() => handleSwipe(message)}
                                >
                                    <div
                                        className="content "
                                        onDoubleClick={() =>
                                            handleReactToMessage(message)
                                        }
                                        onMouseEnter={() =>
                                            setHoveredMessage(message)
                                        }
                                        onMouseLeave={() =>
                                            setHoveredMessage(null)
                                        }
                                    >
                                        {message?.replyMessage && (
                                            <div
                                                className="reply-message"
                                                style={{
                                                    backgroundColor:
                                                        'rgb(29,42,55,1)',
                                                    paddingLeft: '2px',
                                                    paddingRight: '2px',
                                                    borderRadius: '8px',
                                                }}
                                                onClick={() =>
                                                    handleReplyClick(message)
                                                }
                                            >
                                                {/* {message.replyMessage?.text ? message.replyMessage?.text : message.audioUrl ? '🔊' : (message?.attachments && message.attachments?.length > 0) ? '📄' : null} */}
                                                {message.replyMessage?.text &&
                                                message.replyMessage?.text !=
                                                    '' ? (
                                                    <span>
                                                        {
                                                            message.replyMessage
                                                                .text
                                                        }
                                                    </span>
                                                ) : message?.replyMessage &&
                                                  message?.replyMessage
                                                      ?.audioUrl ? (
                                                    <span
                                                        role="img"
                                                        aria-label="audio"
                                                    >
                                                        🔊
                                                    </span>
                                                ) : message?.replyMessage
                                                      .attachments &&
                                                  message.replyMessage
                                                      .attachments.length >
                                                      0 ? (
                                                    <span
                                                        role="img"
                                                        aria-label="audio"
                                                    >
                                                        📄
                                                    </span>
                                                ) : null}
                                            </div>
                                        )}
                                        {/* {message.text} */}
                                        {/* {message?.text && <Linkify >{message.text}</Linkify>} */}
                                        {message.attachments &&
                                            message.attachments.map(
                                                (attachment, index) => {
                                                    const fileExtension =
                                                        attachment
                                                            .split('.')
                                                            .pop()
                                                    let attachmentType
                                                    // console.log("fileExtension........", fileExtension, attachment)
                                                    // Determine attachment type based on file extension
                                                    if (
                                                        fileExtension ===
                                                            'jpg' ||
                                                        fileExtension ===
                                                            'jpeg' ||
                                                        fileExtension ===
                                                            'png' ||
                                                        fileExtension === 'gif'
                                                    ) {
                                                        attachmentType = 'image'
                                                    } else if (
                                                        fileExtension ===
                                                            'mp3' ||
                                                        fileExtension === 'wav'
                                                    ) {
                                                        attachmentType = 'audio'
                                                    } else if (
                                                        fileExtension === 'pdf'
                                                    ) {
                                                        attachmentType = 'pdf'
                                                    } else if (
                                                        fileExtension === 'mp4'
                                                    ) {
                                                        attachmentType = 'video'
                                                    } else {
                                                        attachmentType = 'other'
                                                    }

                                                    // Render attachment based on attachment type
                                                    switch (attachmentType) {
                                                        // case 'image':
                                                        //     return (
                                                        //         <img
                                                        //             key={index}
                                                        //             src={
                                                        //                 attachment
                                                        //             }
                                                        //             alt={`Attachment ${
                                                        //                 index +
                                                        //                 1
                                                        //             }`}
                                                        //             style={{
                                                        //                 width: '100%',
                                                        //                 height: '60%',
                                                        //                 maxWidth:
                                                        //                     '100%',
                                                        //                 maxHeight:
                                                        //                     '100%',
                                                        //             }}
                                                        //         />
                                                        //     )
                                                        case 'image':
                                                            return (
                                                                <div>
                                                                    <img
                                                                        key={
                                                                            index
                                                                        }
                                                                        src={
                                                                            attachment
                                                                        }
                                                                        alt={`Attachment ${
                                                                            index +
                                                                            1
                                                                        }`}
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '60%',
                                                                            maxWidth:
                                                                                '100%',
                                                                            maxHeight:
                                                                                '100%',
                                                                        }}
                                                                    />

                                                                    <a
                                                                        href={
                                                                            attachment
                                                                        }
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        <RiFullscreenFill
                                                                            // onClick={() => handleFullScreen(attachment)}
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                                color: 'white',
                                                                                marginRight:
                                                                                    '10px',
                                                                            }}
                                                                        />
                                                                    </a>

                                                                    <DownloadLink
                                                                        attachment={
                                                                            attachment
                                                                        }
                                                                        fileName={`EvolvChatImage.${fileExtension}`}
                                                                    />
                                                                </div>
                                                            )
                                                        case 'audio':
                                                            return (
                                                                <audio
                                                                    key={index}
                                                                    className="audio-player"
                                                                    style={{
                                                                        width: '160px',
                                                                        height: '35px',
                                                                    }}
                                                                    src={
                                                                        attachment
                                                                    }
                                                                    controls
                                                                />
                                                            )
                                                        case 'pdf':
                                                            return (
                                                                <embed
                                                                    key={index}
                                                                    src={
                                                                        attachment
                                                                    }
                                                                    type="application/pdf"
                                                                    width="100%"
                                                                    height="252px"
                                                                />
                                                            )
                                                        case 'video':
                                                            return (
                                                                <video
                                                                    key={index}
                                                                    controls
                                                                    style={{
                                                                        width: '100%',
                                                                        height: 'auto',
                                                                        maxWidth:
                                                                            '100%',
                                                                    }}
                                                                >
                                                                    <source
                                                                        src={
                                                                            attachment
                                                                        }
                                                                        type="video/mp4"
                                                                    />
                                                                    Your browser
                                                                    does not
                                                                    support the
                                                                    video tag.
                                                                </video>
                                                            )
                                                        default:
                                                            return (
                                                                <div
                                                                    key={index}
                                                                >
                                                                    <a
                                                                        href={
                                                                            attachment
                                                                        }
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        See
                                                                        Attachment
                                                                    </a>
                                                                </div>
                                                            )
                                                    }
                                                },
                                            )}
                                        {message?.text && (
                                            <Linkify
                                                componentDecorator={(
                                                    href,
                                                    text,
                                                    key,
                                                ) => (
                                                    <CustomLink
                                                        key={key}
                                                        href={href}
                                                    >
                                                        {text}
                                                    </CustomLink>
                                                )}
                                            >
                                                {message.text}
                                            </Linkify>
                                        )}
                                        {message?.audioUrl && (
                                            <audio
                                                className="audio-player"
                                                style={{
                                                    width: '160px',
                                                    height: '35px',
                                                }}
                                                src={
                                                    // audioUrl == ''
                                                    // exercise?.feedbackVoiceNoteUrl
                                                    message.audioUrl
                                                }
                                                controls
                                            />
                                        )}
                                        <div
                                            className="message-details"
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                marginTop: '3px',
                                            }}
                                        >
                                            <span
                                                className="message-date"
                                                style={{
                                                    fontSize: '9px',
                                                    color: 'rgb(166 165 166)',
                                                }}
                                            >
                                                {new Date(
                                                    message.date,
                                                ).toLocaleString(undefined, {
                                                    month: 'short',
                                                    day: 'numeric',
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    hour12: true,
                                                })}
                                            </span>
                                            {message?.reactionIcon && (
                                                <span
                                                    role="img"
                                                    aria-label="thumbs-up"
                                                    style={{
                                                        marginLeft: '5px',
                                                    }}
                                                >
                                                    {message.reactionIcon}
                                                </span>
                                            )}
                                            {hoveredMessage === message ? (
                                                <FaReply
                                                    style={{ color: '#7c7e80' }}
                                                    onClick={() =>
                                                        handleReply(message)
                                                    }
                                                />
                                            ) : // <div className="reply-icon" onClick={() => handleSwipe(message)}>
                                            //     {/* Render your reply icon here */}
                                            //     <FaReply />
                                            // </div>
                                            message?.senderType !==
                                              'trainer' ? null : message?.hasRead ? (
                                                <IoCheckmarkDoneSharp
                                                    style={{ color: '#49baf9' }}
                                                />
                                            ) : message?.hasReached ? (
                                                <IoCheckmarkDoneSharp
                                                // style={{ color: '#49baf9' }}
                                                />
                                            ) : (
                                                <IoCheckmarkOutline />
                                            )}
                                        </div>
                                        {/* {reactMessage && reactMessage._id === message._id && (
                                            <span role="img" aria-label="thumbs-up" style={{ marginLeft: '5px' }}>
                                                👍
                                            </span>
                                        )} */}
                                        {/* {message?.reactionIcon && (
                                            <span role="img" aria-label="thumbs-up" style={{ marginLeft: '5px' }}>
                                                {message.reactionIcon}
                                            </span>
                                        )} */}
                                    </div>
                                    {showReactionBar &&
                                        reactMessage?._id === message._id &&
                                        message.senderType != 'trainer' && (
                                            <div className="reaction-bar">
                                                {emojis.map((emoji, index) => (
                                                    <button
                                                        key={index}
                                                        style={{
                                                            padding: '1px 3px',
                                                            backgroundColor:
                                                                '#101317',
                                                            border: 'none',
                                                        }}
                                                        className="reaction-button"
                                                        onClick={() =>
                                                            handleSelectEmoji(
                                                                message,
                                                                emoji,
                                                            )
                                                        }
                                                    >
                                                        {emoji}
                                                    </button>
                                                ))}
                                            </div>
                                        )}
                                </div>
                            </div>
                        ))}
                    </div>

                    <ChatInput
                        handleSendMsg={handleSendMsg}
                        setShowSchedule={setShowSchedule}
                        onScheduleClick={onScheduleClick}
                        socket={socket}
                        clientId={clientId}
                        setIsTyping={setIsTyping}
                        replyMessage={replyMessage}
                        setReplyMessage={setReplyMessage}
                        handleSendAudio={handleSendAudio}
                        attachedFiles={attachedFiles}
                        setAttachedFiles={setAttachedFiles}
                    />
                </Container>
            ) : (
                <Container style={{ zIndex: 10001 }} className="chat-container">
                    <Schedule
                        clientId={clientId}
                        currAutomatedMessages={currAutomatedMessages}
                        setCurrAutomatedMessages={setCurrAutomatedMessages}
                        onClose={() => setShowSchedule(false)}
                        onSave={(scheduledMessage) => {
                            console.log('Scheduled Message:', scheduledMessage)
                            setShowSchedule(false)
                        }}
                        currentChat={currentChat}
                    />
                </Container>
            )}
        </div>
    )
}

const Container = styled.div`
    @media (max-width: 720px) {
        .chat-container {
            width: 100vw;
            height: 100vh;
        }
    }
    position: fixed;
    height: 80vh;
    background-color: #101317;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border: 1px solid #857c7c69;
    width: 30vw;
    display: grid;
    gap: 0.1rem;
    bottom: 0;
    right: 256px;
    overflow: hidden;
    .chat-header {
        position: absolute;
        top: 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 17px 10px;
        background-color: #101317;
        // border-bottom: 1px solid #342e2ead;
        .user-details {
            display: flex;
            align-items: center;
            gap: 1rem;
            .avatar {
                img {
                    border-radius: 50px;
                    height: 2rem;
                    width: 2rem;
                }
            }
            .username {
                h3 {
                    color: white;
                }
            }
        }
    }
    .chat-messages {
        padding: 5px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        margin-bottom: 60px;
        margin-top: 70px;
        border-top: 1px solid #342e2ead;
        border-bottom: 1px solid #342e2ead;
        overflow: auto;
        &::-webkit-scrollbar {
            width: 0.2rem;
            &-thumb {
                background-color: #ffffff39;
                width: 0.1rem;
                border-radius: 1rem;
            }
        }
        .scroll-target {
            background-color: #323538;
            transition: background-color 2s ease; /* Add a transition effect */
        }

        .message {
            display: flex;
            align-items: center;
            .content {
                max-width: 76%;
                overflow-wrap: break-word;
                padding: 5px 10px;
                font-size: 14px;
                border-radius: 20px;
                color: #fff;
                white-space: pre-line; //for activating \n
                @media screen and (min-width: 720px) and (max-width: 1080px) {
                    max-width: 70%;
                }
            }
        }
        .sended {
            justify-content: flex-end;
            .content {
                background-color: #1f273191;
            }
        }
        .recieved {
            justify-content: flex-start;
            .content {
                background-color: #22262b;
            }
        }

        .reaction-button {
            padding: 1px 3px;
        }
    }
`
